module.exports = __webpack_public_path__ + "img/marker_selected.743c9828.svg";